import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const TableSigns = () => {

  const servicesFaqData = [
    {
        question: "What are table signs, and where are they used?",
        answer: "Table signs are compact displays designed to be placed on tables or counters, making them ideal for close-range messaging. They are widely used in events, trade shows, restaurants, retail counters, and corporate offices to provide important information or promote branding. Table signs enhance the aesthetic appeal of a space while serving functional purposes such as displaying menus, event schedules, or promotional offers. These signs are portable, easy to install, and can be tailored to reflect your brand identity. With their versatility, table signs are a key tool for effective communication in various settings."
    },
    {
        question: "What are the benefits of custom table sign printing?",
        answer: "Custom table sign printing allows you to create unique displays that align with your branding and messaging goals. The flexibility to include logos, text, and designs ensures that your table signs stand out while maintaining a professional look. These signs are durable, lightweight, and reusable, making them a cost-effective solution for long-term use. Custom table signs also enhance customer engagement by offering clear and visually appealing information. Whether for promotional displays, corporate branding, or event organization, custom table signs leave a lasting impression."
    },
    {
        question: "Can Printingy handle bulk orders for table sign printing?",
        answer: "Printingy specializes in bulk table sign printing, ensuring cost-effective solutions for large-scale orders. Bulk printing reduces per-unit costs, making it an economical choice for businesses that require multiple signs for events, campaigns, or branding efforts. Our advanced technology ensures consistent quality across all prints, regardless of order size. We understand the importance of timely delivery and ensure that bulk orders are completed efficiently. Whether for a trade show or corporate rollout, Printingy can handle your bulk table sign printing needs."
    },
    {
        question: "What materials are used for personalized table sign printing?",
        answer: "Printingy uses high-quality materials such as acrylic, metal, or durable card stock for personalized table sign printing. Acrylic offers a sleek and modern look, perfect for upscale branding or promotional purposes. Metal signs are highly durable and provide a premium appearance for long-term use. Card stock is lightweight and cost-effective, ideal for temporary displays or events. Each material is selected based on the specific requirements of your project, ensuring a professional and impactful final product."
    },
    {
        question: "What industries benefit from table sign printing services?",
        answer: "Industries such as hospitality, retail, events, education, and corporate branding heavily rely on customizable tabletop sign printing. In hospitality, table signs are used for menu displays or event promotions. Retailers use them for point-of-sale displays or product information. Educational institutions utilize table signs for seminars, workshops, and campus events. Corporate offices leverage them for branding during meetings, conferences, or client presentations. The versatility of table signs makes them indispensable across various industries for effective communication and branding."
    }
  ];
  const [pageTitle, setPageTitle] = useState('Printing of Table Signs');  // Dynamic title state

  useEffect(() => {
    document.title = pageTitle; // Set the document title dynamically
  }, [pageTitle]); // This will run whenever the pageTitle changes
  

  return (
    <div>
    <MetaManager 
  title="Custom Table Signs Printing Services for Businesses"
  description="High-quality printing of table signs for events and branding. Bulk custom table sign printing, personalized table sign printing, and customizable tabletop sign solutions."
  keywords="Printing of Table Signs,
Table Signs Printing,
Custom Table Signs Printing,
Personalized Table Sign Printing,
Customisable Table Top Signs Printing"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Table Signs</h1>
              <h2 className="text-muted">
              Customizable tabletop signs for branding, events, and promotions
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Table signs are versatile tools for enhancing event organization, branding, and promotional efforts. Printingy specializes in Printing Table Signs, offering high-quality and custom table sign printing for various applications.</p>
          <p>Our services include personalized table sign printing with tailored designs that reflect your brand identity. We provide customizable tabletop signs printed with vibrant visuals and durable materials for promotional campaigns, corporate events, or retail displays.</p>
          <p>With bulk printing capabilities and advanced technology, Printingy ensures cost-effective and professional solutions that deliver precision, clarity, and impact.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Table Sign Printing Solutions</h2>
                <h3 className="large-hed">High-quality, durable, and versatile table signs for all occasions</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Table Signs for events, branding, and promotions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk table sign printing at competitive rates for large-scale orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully tailored custom table sign printing with vibrant visuals and unique designs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional, personalized table sign printing for specific branding needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials for long-term use with a premium finish.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced technology ensures sharp graphics and colour consistency.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Lightweight and portable designs for easy handling and setup.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by businesses, event organizers, and retailers nationwide.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/tablsigns.jpg" // Path relative to the public folder
                  alt="Personalized table sign printing for events"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Table Signs Delivered On Time </h2>
            <h3 className="small-hed">Focus on your event while we manage your table sign printing needs</h3>
            <p>At Printingy, we combine advanced printing technology with premium materials to produce exceptional customizable tabletop sign printing. Our services ensure that your table signs are visually impactful, durable, and aligned with your branding.</p>
            <p>We prioritize quality and timely delivery for all bulk orders, ensuring your table signs are ready when needed. Partner with Printingy for professional signage that enhances your branding and promotional efforts.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default TableSigns;
